module.exports = __webpack_public_path__ + "188f4c12e5e6d58d4e4fae072297d147.svg";